import React, { useEffect, useState } from "react";
import {
  Spin,
  Card,
  Form,
  Col,
  Avatar,
  Tag,
  Row,
  InputNumber,
  Popover,
  Modal,
  Button,
  Input,
} from "antd";

import { FONT, USER_STORAGE } from "constants/index";
import {
  notificationErroInternal,
  notificationInfo,
  notificationSucessMsg,
} from "util/api-utils";
import {
  getPlanningUserById,
  saveTraining,
} from "services/planning/planning-service";
import { getById } from "services/user/user-service";
import ManagerialChart from "./managerial-drawer-chart";
import { getUsersBootById } from "services/boot/boot-service";
import TimelineBoot from "./managerial-timeline-boot";
import { UserRound } from "lucide-react";
import { translationsTypes } from "../planning/columns-table";
import moment from "moment";
import { resetPassword } from "services/login/login-service";
import useBreakpoint from "hooks/useBreakpoint";
const { Meta } = Card;

const ManagerialUser = () => {
  const { isMobile, isDesktop } = useBreakpoint();
  const useStackedLayout = !isDesktop;
  const [loading, setLoading] = useState(true);
  const [userTrainer, setUserTrainer] = useState(null);
  const [isBoot, setIsBoot] = useState(null);
  const [activeTraining, setActiveTraining] = useState(false);
  const [user, setUser] = useState(null);
  const [formRefNewPassword] = Form.useForm();
  const [isLoadingPassword, setIsLoadingPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const localStorageItem = localStorage.getItem(USER_STORAGE);
    if (localStorageItem != null) {
      const { id } = JSON.parse(localStorageItem);
      getById(id).then((res) => {
        setIsBoot(res.isBoot);
        setIsModalOpen(res.shouldResetPassword);
        setUser(res);
        getData(res);
      });
    }
  }, [localStorage.getItem(USER_STORAGE)]);

  function getData(user) {
    if (user?.id) {
      var funcGet =
        user.isBoot == true ? getUsersBootById : getPlanningUserById;

      funcGet(user?.id)
        .then((res) => {
          const userTraining =
            user.isBoot == true
              ? {
                  id: user?.id,
                  allTrainings: res.allTrainings,
                  img: user.img,
                  training: res.training,
                  name: user?.name,
                }
              : {
                  id: user?.id,
                  planningTrainings: res[0]?.training,
                  img: user.img,
                  name: user?.name,
                  control: res[0]?.control,
                  planningId: res[0]?.exercises[0]?.planningId,
                };

          if (user.isBoot != true) {
            const training = res[0]?.training ?? [];
            const backSquad = training.find(
              (item) => item.planningType == "BACK_SQUAD"
            );
            const hasOpen = backSquad?.trainings.find(
              (item) => item.forceOpen == true
            );
            const lastTraining = backSquad?.allTrainings?.findLast(
              (item) => item.isDone == true
            )?.updatedAt;
            let lastTrainindDate = "";
            if (lastTraining) {
              lastTrainindDate = moment(lastTraining);
            }
            const nowDate = moment(new Date());

            let showTraining = false;
            if (
              lastTrainindDate != "" &&
              lastTrainindDate?.format("DD/MM/YYYY") !=
                nowDate?.format("DD/MM/YYYY")
            ) {
              showTraining = true;
            }
            if (lastTrainindDate == "") {
              showTraining = true;
            }
            if (hasOpen) {
              showTraining = true;
            }

            if ((user?.isSession == true || hasOpen) && showTraining) {
              setActiveTraining(true);
            } else {
              setActiveTraining(false);
            }
          }

          setUserTrainer(userTraining);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          notificationErroInternal(
            "Aconteceu um erro inesperado, por favor, tente mais tarde"
          );
        });
    }
  }
  function getTranslationType(exercise) {
    var name =
      exercise.planningType == "ADDITIONAL_EXERCISE"
        ? exercise.additionalName
        : exercise.planningType == "NEW_EXERCISE"
        ? exercise.nameCvNew
        : translationsTypes[exercise.planningType];
    return name;
  }
  const DescriptionItem = ({ title }) => (
    <div
      className="site-description-item-profile-wrapper"
      style={{ fontFamily: FONT, fontSize: useStackedLayout ? 13 : 14 }}
    >
      <b>{title}</b>
    </div>
  );

  const CardField = ({ label, value }) => (
    <div className="card-field">
      <span className="card-field-label">{label}</span>
      <span className="card-field-value">{value}</span>
    </div>
  );
  const contentScoreDrop = (
    <div>
      <p>
        Queda ≤ 2% → Excelente – Atleta recuperado e pronto para treinar em alta
        intensidade
      </p>
      <p>
        Queda entre 2% e 5% → Bom – Atleta recuperado, mas pode precisar de
        pequenos ajustes no volume
      </p>
      <p>
        Queda entre 5% e 10% → Moderado – Indica sinais de fadiga; pode ser
        necessário reduzir o volume do treinamento
      </p>
      <p>
        Queda entre 10% e 15% → Ruim – Indica cansaço acumulado; sugere
        necessidade de um treino estabilizador ou ajuste no volume e na
        intensidade do treino
      </p>
      <p>
        Queda superior a 15% → Crítico – Indica risco de overtraining; é
        recomendado descanso completo ou um ajuste profundo na carga de
        treinamento
      </p>
    </div>
  );
  const contentScoreWellBeing = (
    <div>
      <p>
        4,5 a 5,0 → Excelente – Atleta recuperado e pronto para treinar em alta
        intensidade.
      </p>
      <p>
        3,5 a 4,4 → Bom – Atleta recuperado, mas pode precisar de ajustes
        menores na carga de treino.
      </p>
      <p>
        2,5 a 3,4 → Moderado – Indica sinais de fadiga; pode ser necessário
        reduzir a carga ou fazer um treino mais leve.
      </p>
      <p>
        1,5 a 2,4 → Ruim – Indica cansaço acumulado; sugere necessidade de
        descanso ativo ou ajuste significativo na carga.
      </p>
      <p>
        1,0 a 1,4 → Crítico – Indica risco de overtraining; é recomendado
        descanso completo ou um ajuste profundo no ciclo de treino.
      </p>
    </div>
  );
  function getWeek(planningExercise, name) {
    const week = planningExercise[0]?.trainings[0]?.load;
    const type = planningExercise[0]?.trainings[0]?.orderTraining;

    if (week) {
      const typeTraining = type % 2 === 0 ? "B" : "A";
      const color = type % 2 === 0 ? "geekblue" : "green";

      return (
        <div>
          {name} - Semana {week} -{" "}
          <Tag color={color} key={typeTraining}>
            {typeTraining.toUpperCase()}
          </Tag>
        </div>
      );
    }
    return name + " - Cíclo Finalizado";
  }
  function hasBackSquad(exercises) {
    return (
      exercises.filter((item) => item.planningType == "BACK_SQUAD").length > 0
    );
  }
  const Exercises = ({ exercises }) => {
    const last = exercises[0]?.allTrainings.slice(-1);

    const load = exercises[0]?.trainings[0]?.load ?? last[0]?.load ?? 1;

    if (useStackedLayout) {
      return (
        <div className="exercise-list exercise-list-mobile custom-scroll">
          {exercises.map((exercise, index) => (
            <div
              key={index}
              className="responsive-card-item exercise-row-mobile"
            >
              <CardField
                label="Exercício"
                value={getTranslationType(exercise)}
              />
              <CardField
                label="Carga"
                value={exercise[`load${load}`] + "kg"}
              />
              <CardField
                label="VMP"
                value={
                  exercise[`vmp${load}`] != null
                    ? exercise[`vmp${load}`] + " - VMP"
                    : "—"
                }
              />
              <CardField
                label={exercise.planningType == "BARBELL_JUMP" ? "ALT(CM)" : "%1RM"}
                value={
                  exercise[`rm${load}`] != null
                    ? exercise.planningType == "BARBELL_JUMP"
                      ? exercise[`rm${load}`] + " - ALT(CM)"
                      : exercise[`rm${load}`] + " - %1RM"
                    : "—"
                }
              />
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="exercise-list exercise-list-desktop custom-scroll">
        <div className="exercise-table-desktop">
          <div className="exercise-table-header">
            <span>Exercício</span>
            <span>Carga</span>
            <span>VMP</span>
            <span>%1RM</span>
          </div>
          {exercises.map((exercise, index) => (
            <div key={index} className="exercise-table-row">
              <span className="exercise-table-cell exercise-name">
                {getTranslationType(exercise)}
              </span>
              <span className="exercise-table-cell">
                {exercise[`load${load}`]}kg
              </span>
              <span className="exercise-table-cell">
                {exercise[`vmp${load}`] != null
                  ? exercise[`vmp${load}`]
                  : "—"}
              </span>
              <span className="exercise-table-cell">
                {exercise[`rm${load}`] != null
                  ? exercise.planningType == "BARBELL_JUMP"
                    ? exercise[`rm${load}`] + " cm"
                    : exercise[`rm${load}`] + "%"
                  : "—"}
              </span>
            </div>
          ))}
        </div>
      </div>
    );
  };
  function getScoreControl(value, showScore) {
    let color = "green";
    if (value < -10) {
      color = "red";
    }
    if (value <= -6 && value >= -10) {
      color = "yellow";
    }

    if (showScore) {
      return (
        <Popover content={contentScoreDrop} title="Valores de Queda">
          <div>
            <Tag color={color}>{value}</Tag>
          </div>
        </Popover>
      );
    } else {
      return (
        <div>
          <Tag color={color}>{value}</Tag>
        </div>
      );
    }
  }
  function getScoreControlWellBeing(value) {
    let color = "green";
    if (value < 1.5) {
      color = "red";
    }
    if (value < 2.5 && value >= 1.5) {
      color = "orange";
    }
    if (value < 3.5 && value >= 2.5) {
      color = "yellow";
    }
    if (value < 4.5 && value >= 3.5) {
      color = "blue";
    }
    return (
      <Popover content={contentScoreWellBeing} title="Interpretação Score">
        <div>
          <Tag color={color}>{value}</Tag>
        </div>
      </Popover>
    );
  }
  const ControlSection = ({ control }) => {
    if (!control) return null;

    if (useStackedLayout) {
      return (
        <div className="responsive-card-item control-section-mobile">
          <CardField label="CMJ PRÉ" value={control.cmjFirst} />
          <CardField
            label="Queda % (pré)"
            value={getScoreControl(control.cmjFirstDrop, true)}
          />
          <CardField
            label="Score"
            value={getScoreControlWellBeing(control.averageWellBeing)}
          />
          <CardField label="CMJ PÓS" value={control.cmjSecond} />
          <CardField
            label="Queda % (pós)"
            value={getScoreControl(control.cmjSecondDrop)}
          />
        </div>
      );
    }

    return (
      <div className="control-grid-desktop">
        <div className="control-cell">
          <span className="control-cell-label">CMJ PRÉ</span>
          <span className="control-cell-value">{control.cmjFirst}</span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">Queda %</span>
          <span className="control-cell-value">
            {getScoreControl(control.cmjFirstDrop, true)}
          </span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">Score</span>
          <span className="control-cell-value">
            {getScoreControlWellBeing(control.averageWellBeing)}
          </span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">CMJ PÓS</span>
          <span className="control-cell-value">{control.cmjSecond}</span>
        </div>
        <div className="control-cell">
          <span className="control-cell-label">Queda %</span>
          <span className="control-cell-value">
            {getScoreControl(control.cmjSecondDrop)}
          </span>
        </div>
      </div>
    );
  };
  const CardTrainings = () => {
    const [formUser] = Form.useForm();
    const user = userTrainer;
    if (user == null) {
      return <div></div>;
    }
    const planExercise =
      user?.planningTrainings?.filter((p) => p.planningType == "BACK_SQUAD") ??
      [];
    let isOpen = false;
    if (planExercise.length > 0) {
      const exercise = planExercise[0].trainings;
      if (exercise.length > 0) {
        isOpen = exercise[0].forceOpen;
        formUser.setFieldValue("vmp1", exercise[0].vmp1);
        formUser.setFieldValue("vmp2", exercise[0].vmp2);
        formUser.setFieldValue("vmp3", exercise[0].vmp3);
        formUser.setFieldValue("vmp4", exercise[0].vmp4);
      }
    }

    return (
      <Col key={user.id} xs={24}>
        <Card
          className="training-card"
          style={{
            width: "100%",
            marginBottom: 16,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Meta
            className="training-card-meta"
            avatar={
              <Avatar
                src={user?.img}
                icon={
                  <UserRound size={useStackedLayout ? 48 : 56} />
                }
                size={useStackedLayout ? 48 : 56}
              />
            }
            title={<div>{getWeek(user.planningTrainings, user.name)}</div>}
            description={
              <div>
                {useStackedLayout && (
                  <Row>
                    <Col span={9}>
                      <DescriptionItem title={"Exercícios"} />
                    </Col>
                  </Row>
                )}
                <Exercises exercises={user.planningTrainings} />

                {hasBackSquad(user.planningTrainings) &&
                  (useStackedLayout ? (
                    <>
                      <Row style={{ marginTop: 10 }}>
                        <Col span={24}>
                          <DescriptionItem title={"VMP Agachamento"} />
                        </Col>
                      </Row>
                      <Form
                        form={formUser}
                        layout="vertical"
                        className="training-card-form-mobile"
                      >
                        <Row gutter={16}>
                          <Col xs={12} lg={6}>
                            <Form.Item name="vmp1">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Item name="vmp2">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Item name="vmp3">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} lg={6}>
                            <Form.Item name="vmp4">
                              <InputNumber
                                decimalSeparator=","
                                style={{ fontFamily: FONT, width: "100%" }}
                                onBlur={() =>
                                  setVmp(formUser, user.planningId, isOpen)
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </>
                  ) : (
                    <div className="vmp-row-desktop">
                      <span className="vmp-label">VMP Agachamento</span>
                      <Form form={formUser} className="vmp-form">
                        <div className="vmp-inputs">
                          <Form.Item name="vmp1">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                          <Form.Item name="vmp2">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                          <Form.Item name="vmp3">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                          <Form.Item name="vmp4">
                            <InputNumber
                              decimalSeparator=","
                              style={{ fontFamily: FONT, width: "100%" }}
                              onBlur={() =>
                                setVmp(formUser, user.planningId, isOpen)
                              }
                            />
                          </Form.Item>
                        </div>
                      </Form>
                    </div>
                  ))}
                <ControlSection control={user.control} />
              </div>
            }
          />
        </Card>
      </Col>
    );
  };
  function setVmp(formUser, planningId, isOpen, forceClose) {
    setLoading(true);
    const obj = {
      isDone: false,
      planningId: [planningId],
      vmp1: formUser.getFieldValue("vmp1"),
      vmp2: formUser.getFieldValue("vmp2"),
      vmp3: formUser.getFieldValue("vmp3"),
      vmp4: formUser.getFieldValue("vmp4"),
      isOpen: isOpen,
      forceClose: forceClose,
    };
    saveTraining(obj)
      .then(() => {
        getData(user);
      })
      .catch((err) => {
        setLoading(false);
        notificationErroInternal(
          "Aconteceu um erro inesperado, por favor, tente mais tarde"
        );
      });
  }

  const handleOk = () => {
    setIsLoadingPassword(true);
    formRefNewPassword
      .validateFields()
      .then((values) => {
        if (values.password != values.confirmPassword) {
          notificationInfo("As senhas devem ser iguais!");
          setIsLoadingPassword(false);
          return;
        }

        const request = {
          id: user.id,
          password: values.password,
        };
        resetPassword(request)
          .then(() => {
            notificationSucessMsg("Senha alterada com sucesso!");
            handleCancel();
          })
          .catch((err) => {
            setIsLoadingPassword(false);
            notificationErroInternal(
              "Aconteceu um erro inesperado, por favor, tente mais tarde"
            );
          });
      })
      .catch((errors) => {
        setIsLoadingPassword(false);
        console.log(errors);
      });
  };

  const handleCancel = () => {
    formRefNewPassword.resetFields();
    setIsModalOpen(false);
    setIsLoadingPassword(false);
  };

  return (
    <div className="container-managerial">
      <Spin size="large" spinning={loading}>
        {activeTraining == true && <CardTrainings />}
        {isBoot == true ? (
          <TimelineBoot user={userTrainer} />
        ) : (
          <ManagerialChart user={userTrainer} />
        )}
      </Spin>
      <Modal
        className="modal-password"
        style={{ textAlign: "center" }}
        title="Definir Nova Senha"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoadingPassword}
            onClick={handleOk}
          >
            Salvar
          </Button>,
        ]}
      >
        <Form
          form={formRefNewPassword}
          layout={"vertical"}
          style={{ maxWidth: 600, fontFamily: FONT }}
        >
          <Form.Item
            label="Senha"
            name="password"
            rules={[
              {
                required: true,
                message: "È necessário informar a senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            label="Confirmar Senha"
            name="confirmPassword"
            rules={[
              {
                required: true,
                message: "È necessário informar a confirmação de senha",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};
export default ManagerialUser;
